<script>
    import app from "../../stores/app";
    import Button from "../../controls/Button.svelte";
    import Product from "./Product.svelte";
</script>

<div class="container mt-lg">
    <h2 class="text-center mt-none">{ $app.lang.choose_your_tickets }</h2>
    {#each $app.products as product}
        <Product bind:product={ product }/>
        <hr>
    {/each}
    <p style="margin-top: -20px;">Προσοχή! Η πρόσβαση στα παιχνίδια νερού γίνεται με βάση το ύψος.</p>

    <div class="row buttons-row">
        <div class="col-6">
        </div>
        <div class="col-6">
            <Button label="{ $app.lang.btnNext }" type="next" block on:click={ () => $app.cartStep = 2 }/>
        </div>
    </div>
    <div class="how-to-pay">
        <div class="cards">
            <img src="/app/assets/images/how-to-pay.png" alt="how to pay">
        </div>
    </div>
</div>
